import { useEffect } from "react";
import { CLOSEICON } from "../Utils/icons";
const Modal = ({ isOpen, onClose, children, cstmClassName, title }) => {
  useEffect(() => {
    if (isOpen === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isOpen]);
  let className = cstmClassName + " modal-content cstm";
  return (
    <>
      {isOpen && (
        <div className="modal-overlay">
          <div className={className}>
            <button className="close-button" onClick={onClose}>
              <CLOSEICON />
            </button>
            <div className="card-title">
              <h1>{title}</h1>
            </div>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
